<template>
  <div :class="['simple-words', isMobile ? '' : 'simple-words-pc']">
    <div class="nav-content">
      <div class="nav-title">{{ robotNav.tit }}</div>
      <div class="nav-list">
        <div v-for="(item, index) in getPageData(robotNav, 10)" :key="index" class="nav-list-link">
          <message-link
            v-if="item.action === 5"
            :key="index"
            :link="{
              url: `qdweb://webim/message/ext2robotsendc2b?content=${textToUnicode(item.name)}&ext=${textToUnicode(JSON.stringify(item))}`,
              text: item.name,
              canClickAgain: true,
            }"
            @click="onClick(item, {robot_nav_msg_dir: 1})"
          ></message-link>
          <div v-else :key="index" class="nav-item">
            <div class="nav-link" @click="onClick(item)">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div
        v-if="robotNav.showChange"
        class="nav-change"
        @click="onChange(robotNav)"
      >
        <div class="nav-change-box">
          <img class="batch-head-icon icon-primay" src="../assets/changeBatch.svg"/>
          换一批
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import robotNavMixin from './robot-nav-mixin.js';
import MessageLink from '@/components/MessageLink';
import { textToUnicode } from '@/utils/htmlDecode';

/**
 * @component 机器人导航 - 简单文字型
 */
export default {
  mixins: [robotNavMixin],
  components: {
    MessageLink,
  },
  methods: {
    /**
     * 将字符串中的 & 符转成unicode编码
     */
    textToUnicode(text)  {
      return textToUnicode(text);
    },
  },
};
</script>

<style lang="less" scoped>
.simple-words {
  .nav-content {
    border-radius: 6px;
    padding: 12px 16px;
    background-color: #fff;
    .nav-title {
      font-size: 13px;
      color: #78849e;
      line-height: 18px;
    }
    .nav-list {
      overflow: hidden;
      margin-top: 6px;
      &-link {
        display: block;
        line-height: 28px;
        font-size: 13px;
        color: @primary;
      }
      .nav-item {
        height: 24px;
        .nav-link {
          cursor: pointer;
          line-height: 24px;
          font-size: 13px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .nav-change {
      height: 30px;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .nav-change-box {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: @primary;
        cursor: pointer;

        .batch-head-icon {
          height: 12px;
          width: 12px;
          margin-right: 4px;
        }
      }
    }
  }
}
.simple-words-pc {
  width: 336px;
  .nav-content {
    border-radius: 6px;
    box-shadow: 0 1px 10px 0 #e1e6f0;
    margin-top: 2px;
    background-color: #fff;
  }
}
</style>
